import { CenterLanguage } from 'src/app/models/center-model/center-language.model';
import { CenterCurrency } from './center-currency.model';

export class Center {

    private active: boolean;
    private centerCode: string;
    private centerContactName: string;
    private centerImageName: string;
    private centerImageRaw: string;
    private centerImageUrl: string;
    private centerLanguageList: CenterLanguage[];
    private centerMail: string;
    private centerName: string;
    private centerTypeInternalId: string;
    private centerTypeName: string;
    private cif: string;
    private city: string;
    private companyInternalId: string;
    private country: string;
    private defaultLanguage: CenterLanguage;
    private faxNumber: string;
    private fiscalAddress: string;
    private fiscalName: string;
    private gpsLatitude: number;
    private gpsLongitude: number;
    private imageL: string;
    private imageM: string;
    private imageS: string;
    private imageXl: string;
    private infoAlert: string;
    private internalId: string;
    private maxRadius: number;
    private online: boolean;
    private phoneNumber: string;
    private province: string;
    private region: string;
    private street: string;
    private visible: boolean;
    private zipCode: string;
    private timeZone: string;
    private currency: CenterCurrency;

    constructor(active?: boolean, infoAlert?: string, centerCode?: string, centerContactName?: string, centerImageName?: string, centerImageRaw?: string, centerImageUrl?: string, centerLanguageList?: CenterLanguage[], centerMail?: string, centerName?: string, centerTypeInternalId?: string, centerTypeName?: string, cif?: string, city?: string, companyInternalId?: string, country?: string, defaultLanguage?: CenterLanguage, faxNumber?: string, fiscalAddress?: string, fiscalName?: string, gpsLatitude?: number, gpsLongitude?: number, internalId?: string, imageS?: string, imageM?: string, imageL?: string, imageXl?: string, maxRadius?: number, phoneNumber?: string, online?: boolean, province?: string, region?: string, street?: string, visible?: boolean, zipCode?: string, timeZone?: string, currency?: CenterCurrency) {
        this.active = active;
        this.infoAlert = infoAlert;
        this.centerCode = centerCode;
        this.centerContactName = centerContactName;
        this.centerImageName = centerImageName;
        this.centerImageRaw = centerImageRaw;
        this.centerImageUrl = centerImageUrl;
        this.centerLanguageList = centerLanguageList;
        this.centerMail = centerMail;
        this.centerName = centerName;
        this.centerTypeInternalId = centerTypeInternalId;
        this.centerTypeName = centerTypeName;
        this.defaultLanguage = defaultLanguage;
        this.cif = cif;
        this.city = city;
        this.imageS = imageS;
        this.imageM = imageM;
        this.imageL = imageL;
        this.imageXl = imageXl;
        this.companyInternalId = companyInternalId;
        this.country = country;
        this.faxNumber = faxNumber;
        this.fiscalAddress = fiscalAddress;
        this.fiscalName = fiscalName;
        this.gpsLatitude = gpsLatitude;
        this.gpsLongitude = gpsLongitude;
        this.internalId = internalId;
        this.maxRadius = maxRadius;
        this.phoneNumber = phoneNumber;
        this.online = online;
        this.province = province;
        this.region = region;
        this.street = street;
        this.visible = visible;
        this.zipCode = zipCode;
        this.timeZone = timeZone;
        this.currency = currency;
    }

    public get Active(): boolean {
        return this.active;
    }
    public get InfoAlert(): string {
        return this.infoAlert;
    }
    public get CenterCode(): string {
        return this.centerCode;
    }
    public get CenterContactName(): string {
        return this.centerContactName;
    }
    public get CenterImageName(): string {
        return this.centerImageName;
    }
    public get CenterImageRaw(): string {
        return this.centerImageRaw;
    }
    public get CenterImageUrl(): string {
        return this.centerImageUrl;
    }
    public get CenterLanguageList(): CenterLanguage[] {
        return this.centerLanguageList;
    }
    public get CenterMail(): string {
        return this.centerMail;
    }
    public get CenterName(): string {
        return this.centerName;
    }
    public get CenterTypeInternalId(): string {
        return this.centerTypeInternalId;
    }
    public get CenterTypeName(): string {
        return this.centerTypeName;
    }
    public get Cif(): string {
        return this.cif;
    }
    public get City(): string {
        return this.city;
    }
    public get CompanyInternalId(): string {
        return this.companyInternalId;
    }
    public get Country(): string {
        return this.country;
    }
    public get DefaultLanguage(): CenterLanguage {
        return this.defaultLanguage;
    }
    public get FaxNumber(): string {
        return this.faxNumber;
    }
    public get FiscalAddress(): string {
        return this.fiscalAddress;
    }
    public get FiscalName(): string {
        return this.fiscalName;
    }
    public get GpsLatitude(): number {
        return this.gpsLatitude;
    }
    public get GpsLongitude(): number {
        return this.gpsLongitude;
    }
    public get InternalId(): string {
        return this.internalId;
    }
    public get ImageS(): string {
        return this.imageS;
    }
    public get ImageM(): string {
        return this.imageM;
    }
    public get ImageL(): string {
        return this.imageL;
    }
    public get ImageXl(): string {
        return this.imageXl;
    }
    public get MaxRadius(): number {
        return this.maxRadius;
    }
    public get Online(): boolean {
        return this.online;
    }
    public get PhoneNumber(): string {
        return this.phoneNumber;
    }
    public get Province(): string {
        return this.province;
    }
    public get Region(): string {
        return this.region;
    }
    public get Street(): string {
        return this.street;
    }
    public get Visible(): boolean {
        return this.visible;
    }
    public get ZipCode(): string {
        return this.zipCode;
    }
    public get TimeZone(): string {
        return this.timeZone;
    }
    public get Currency(): CenterCurrency {
        return this.currency;
    }


    public set Active(active: boolean) {
        this.active = active;
    }
    public set InfoAlert(infoAlert: string) {
        this.infoAlert = infoAlert;
    }
    public set CenterCode(centerCode: string) {
        this.centerCode = centerCode;
    }
    public set CenterContactName(centerContactName: string) {
        this.centerContactName = centerContactName;
    }
    public set CenterImageName(centerImageName: string) {
        this.centerImageName = centerImageName;
    }
    public set CenterImageRaw(centerImageRaw: string) {
        this.centerImageRaw = centerImageRaw;
    }
    public set CenterImageUrl(centerImageUrl: string) {
        this.centerImageUrl = centerImageUrl;
    }
    public set CenterLanguageList(centerLanguageList: CenterLanguage[]) {
        this.centerLanguageList = centerLanguageList;
    }
    public set CenterMail(centerMail: string) {
        this.centerMail = centerMail;
    }
    public set CenterName(centerName: string) {
        this.centerName = centerName;
    }
    public set CenterTypeInternalId(centerTypeInternalId: string) {
        this.centerTypeInternalId = centerTypeInternalId;
    }
    public set CenterTypeName(centerTypeName: string) {
        this.centerTypeName = centerTypeName;
    }
    public set Cif(cif: string) {
        this.cif = cif;
    }
    public set City(city: string) {
        this.city = city;
    }
    public set CompanyInternalId(companyInternalId: string) {
        this.companyInternalId = companyInternalId;
    }
    public set Country(country: string) {
        this.country = country;
    }
    public set DefaultLanguage(defaultLanguage: CenterLanguage) {
        this.defaultLanguage = defaultLanguage;
    }
    public set FaxNumber(faxNumber: string) {
        this.faxNumber = faxNumber;
    }
    public set FiscalAddress(fiscalAddress: string) {
        this.fiscalAddress = fiscalAddress;
    }
    public set FiscalName(fiscalName: string) {
        this.fiscalName = fiscalName;
    }
    public set GpsLatitude(gpsLatitude: number) {
        this.gpsLatitude = gpsLatitude;
    }
    public set GpsLongitude(gpsLongitude: number) {
        this.gpsLongitude = gpsLongitude;
    }
    public set InternalId(internalId: string) {
        this.internalId = internalId;
    }
    public set ImageS(imageS: string) {
        this.imageS = imageS;
    }
    public set ImageM(imageM: string) {
        this.imageM = imageM;
    }
    public set ImageL(imageL: string) {
        this.imageL = imageL;
    }
    public set ImageXl(imageXl: string) {
        this.imageXl = imageXl;
    }
    public set MaxRadius(maxRadius: number) {
        this.maxRadius = maxRadius;
    }
    public set Online(online: boolean) {
        this.online = online;
    }
    public set PhoneNumber(phoneNumber: string) {
        this.phoneNumber = phoneNumber;
    }
    public set Province(province: string) {
        this.province = province;
    }
    public set Region(region: string) {
        this.region = region;
    }
    public set Street(street: string) {
        this.street = street;
    }
    public set Visible(visible: boolean) {
        this.visible = visible;
    }
    public set ZipCode(zipCode: string) {
        this.zipCode = zipCode;
    }
    public set TimeZone(timeZone: string) {
        this.timeZone = timeZone;
    }
    public set Currency(currency: CenterCurrency) {
        this.currency = currency;
    }

}
